import React from 'react';
import ESpotContent from '../../../components/ESpotContent/ESpotContent';
import ContextualFit from '../../../components/ContextualFit/ContextualFit';

export default function FitInformationSection({
  textContent,
  fitInformation,
  eSpotContent,
  reviewData,
  hasFitInfo,
}) {
  return (
    <div className="fit-information-section">
      <h4>{textContent.fitHeaderText?.value}</h4>
      <ul>
        {hasFitInfo && (
          <li>
            <p className="fit-information-section__model-specs-text">
              {textContent.modelText?.value}
              :
              {fitInformation.ofpModelHeight.replace(/&quot;/g, '"')}
              {' '}
              <span className="lowercase">{textContent.wearingSizeText?.value}</span>
              {' '}
              {fitInformation.ofpModelSize}
            </p>
          </li>
        )}
        {reviewData && reviewData.showFitRecommendation && (
          <li>
            <ContextualFit
              className="no-margin"
              tmntData={textContent}
              reviewData={reviewData}
            />
          </li>
        )}
      </ul>
      <ESpotContent eSpotData={eSpotContent?.pdp_sizefitaccordion} />
    </div>
  );
}
